import { AfterViewInit, Directive, ElementRef, Inject, Input, OnDestroy } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { Subject } from 'rxjs';

import { CommonWindow } from '@core/domain/models/common-window.model';
import { CorePlatformService } from '@core/infrastructure/platform/platform.service';

@Directive({
    selector: '[setHeightStyleDirective]',
    standalone: true,
})
export class SetHeightStyleDirective implements AfterViewInit, OnDestroy {
    @Input('setHeightStyleDirective') public cssVarName: string;

    private readonly destroySubject = new Subject<void>();

    private readonly bodyEl: HTMLBodyElement;

    private heightComponent = 0;

    private domEl: ElementRef;

    private observer: MutationObserver;

    constructor(
        private readonly elementRef: ElementRef,
        @Inject(WINDOW) private readonly window: CommonWindow,
        private readonly platformService: CorePlatformService,
    ) {
        if (this.platformService.isBrowser()) {
            this.bodyEl = this.window.document.querySelector('body');
        }
    }

    public ngAfterViewInit() {
        this.domEl = this.elementRef.nativeElement;
        this.setCssClassHeight();
        this.runMutationObserver();
    }

    private setCssClassHeight(): void {
        if (this.platformService.isBrowser()) {
            const height = (this.domEl as any)?.offsetHeight;
            if (height && height !== this.heightComponent) {
                this.heightComponent = height;
                this.bodyEl.style?.setProperty(this.cssVarName, `${height}px`);
            }
        }
    }

    private runMutationObserver(): void {
        if (this.platformService.isBrowser()) {
            this.observer = new MutationObserver(() => {
                this.setCssClassHeight();
            });
            this.observer.observe(
                this.domEl as any,
                { attributes: true, childList: true, subtree: true },
            );
        }
    }

    private destroyObserver(): void {
        if (this.platformService.isBrowser()) {
            this.observer?.disconnect();
            this.destroySubject.next();
            this.destroySubject.complete();
        }
    }

    public ngOnDestroy() {
        if (this.platformService.isBrowser()) {
            this.destroyObserver();
        }
    }
}
